module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAcCAYAAACK7SRjAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAAE7SURBVEhL7ZbBSwJBGMX3/48oIqQIT3Xo0sFLp24RlpmFJRYFgYVSmmBa2Ja85rGz63zrt7qZHYJ98Fh25n2/2Z1vB9bDFH2OgOoTcHAPbFeBtVJw5T3H/S8bTFAivNkH8hfAUjHZmxWg0bMFilT4YQNYPtaBmvkmmibgtbYOoHNlfZyutCzAkYC/fgT76hZtnAH1DjC0+8vrbTfYEje3aupe3oNMKAHfu5YFO5djaFxs5m5N5nnvSsC5ehhcOZl8krh6Q1nDPvELCxXB22/jEM23SKPCjaxrDeyEUQSPN5JfTBqVmrLObWwEP3qQoatnOzFDzLl15IT65/CBD+zfydC8cHJ4XiiPDfnJUU9j8oqPBj7tSP/G66cGrk0syhlcdQZXncFV/y181o/PvN46N3D+Jix6AYLrHeAbpm/T53QIiKAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/number.png
// module id = +azW
// module chunks = 3